<h4>{{ name() }}</h4>
<table [class]="{ 'bottom-border': hasBottomBorder() }">
	<thead>
		<tr>
			<th scope="col">{{ 'client.relatives.details.category' | transloco }}</th>
			<th scope="col">{{ 'client.relatives.details.legal_guardian' | transloco }}</th>
			<th scope="col">{{ 'client.relatives.communication' | transloco }}</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>{{ relative().categoryPersonCategory.name }}</td>
			<td>
				{{ 'client.relatives.' + relative().isSupervisor | transloco }}
			</td>
			<td>
				@for (cp of relative().contactPoints; track cp.id) {
					{{ cp.contactValue }}<br />
				}
			</td>
		</tr>
	</tbody>
</table>
